module.exports = __webpack_public_path__ + "img/avatar-pressure-normal.b14cc2be.png";